<template>
  <div
    :class="getVariant('video')"
    :style="getStyle"
    class="video"
  >
    <div
      class="video__placeholder"
      :class="{'video__placeholder--is-loading' : ready}"
    />
    <!-- Wrapper -->
    <div class="video__wrapper">
      <slot
        :onplay="playing()"
      />
    </div>

    <!-- Title -->
    <div class="video__title">
      <h1
        v-inview:class="['animate']"
        class="video__title__line"
      >
        <slot name="title-first" />
      </h1>

      <h2
        v-inview:class="['animate']"
        class="video__title__line"
      >
        <slot name="title-second" />
      </h2>
    </div>

    <!-- Icon (scroll) -->
    <div
      :class="{ 'video__icon--center': !hasFullscreen }"
      class="video__icon video__icon--left"
    >
      <icon-scroll-view v-inview:class="['animate']" />
    </div>

    <!-- Icon (play) -->
    <div
      v-if="hasFullscreen"
      class="video__icon video__icon--right"
    >
      <icon-play-view
        v-inview:class="['animate']"
        :immediate="true"
        :loading="loading"
        @click="clickFullscreen"
      />
    </div>

    <!-- Icon (arrow) -->
    <div class="video__icon video__icon--bottom">
      <i class="icon-arrow animation-jump" />
    </div>

    <!-- Fullscreen -->
    <video-fullscreen-view
      v-if="hasFullscreen"
      :video-id="videoId"
      :fullscreen="fullscreen"
      @close-fullscreen="fullscreen = false"
      @click-esc="fullscreen = false"
      @stop-loading="loading = false"
    />
  </div>
</template>

<script>
import variant from '@/mixins/variant';

export default {
  name: 'VideoView',

  components: {
    VideoFullscreenView: () => import('./video-fullscreen-view'),
    IconScrollView: () => import('@/icons/icon-scroll-view'),
    IconPlayView: () => import('@/icons/icon-play-view')
  },

  mixins: [variant],

  props: {
    videoId: {
      type: String,
      required: false,
      default: ''
    },

    hasFullscreen: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      loading: false,
      fullscreen: false,
      ready: false
    };
  },

  computed: {
    getStyle() {
      return {
        height: 'calc(100vh - 100px)'
      };
    }
  },

  mounted() {
    this.height = `calc(${window.innerHeight}px - 100px)`;
    // Play video (workaround)
    setTimeout(() => {
      this.$el.querySelector('.video__wrapper > video').play();
    }, 500);
  },

  methods: {
    clickFullscreen() {
      this.loading = true;
      this.fullscreen = true;
    },

    playing() {
      this.ready = true;
    }
  }
};
</script>

<style lang="scss" src="@/assets/components/video/video-view.scss"></style>



// WEBPACK FOOTER //
// video-view.vue